import { render } from "./PaginationInfo.vue?vue&type=template&id=c063e8a6&ts=true"
import script from "./PaginationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationInfo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ui/pagination/PaginationInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c063e8a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c063e8a6', __exports__)) {
    console.log('reload')
    api.reload('c063e8a6', __exports__)
  }
  
  module.hot.accept("./PaginationInfo.vue?vue&type=template&id=c063e8a6&ts=true", () => {
    console.log('re-render')
    api.rerender('c063e8a6', render)
  })

}


export default __exports__